define(["underscore","@bingads-webui/page-ready","prop-types"], function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__52__, __WEBPACK_EXTERNAL_MODULE__55__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 47);
/******/ })
/************************************************************************/
/******/ ({

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(48);


/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PerfMarkerFactory", {
  enumerable: true,
  get: function get() {
    return _index.PerfMarkerFactory;
  }
});
Object.defineProperty(exports, "functionWithPerfMarker", {
  enumerable: true,
  get: function get() {
    return _helpers.functionWithPerfMarker;
  }
});
Object.defineProperty(exports, "asyncFunctionWithPerfMarker", {
  enumerable: true,
  get: function get() {
    return _helpers.asyncFunctionWithPerfMarker;
  }
});
Object.defineProperty(exports, "perfMarkerPropTypes", {
  enumerable: true,
  get: function get() {
    return _proptypes.perfMarkerPropTypes;
  }
});

var _index = __webpack_require__(49);

var _helpers = __webpack_require__(53);

var _proptypes = __webpack_require__(54);

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PerfMarkerFactory = void 0;

var _activity = __webpack_require__(50);

var _marker = __webpack_require__(51);

let instrumentation;
const filesFetched = [];

class PerfMarkerFactory {
  static init(instr) {
    instrumentation = instr;
  }

  static createMarker(name, markerOptions = {
    autoEnd: false,
    isActiveChild: true
  }, activity = (0, _activity.createActivity)(instrumentation), parentMarker = {}) {
    const isFileFetched = filesFetched.indexOf(name) > -1;

    if (!isFileFetched) {
      filesFetched.push(name);
    }

    return new _marker.PerfMarker(name, markerOptions, isFileFetched, activity, parentMarker);
  }

  static isPerfMarker(obj) {
    return obj instanceof _marker.PerfMarker;
  }

  static isInit() {
    return instrumentation !== null && instrumentation !== undefined;
  }

}

exports.PerfMarkerFactory = PerfMarkerFactory;

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createActivity = createActivity;

var _underscore = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const schema = {
  scenario: [{
    name: 'perfMarker',
    value: 'PerfMarker',
    setting: {},
    activity: [{
      name: 'sendLog',
      value: 'SendLog'
    }]
  }]
};
let perfScenario = null;

function getScenario(instrumentation) {
  if (_underscore.default.isEmpty(perfScenario)) {
    instrumentation.addScenario(schema);
    perfScenario = instrumentation.perfMarker.create();
  }

  return perfScenario;
}

function createActivity(instrumentation) {
  const scenario = getScenario(instrumentation);
  return scenario.sendLog.create();
}

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PerfMarker = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

var _pageReady = __webpack_require__(52);

var _index = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

let isPageReadyFulfilled = false;

_pageReady.PageReady.afterPageReady().then(() => {
  isPageReadyFulfilled = true;
});

function markTime() {
  return {
    time: performance.now(),
    activeTime: _underscore.default.result(performance, 'activeTime', NaN)
  };
}

function isMarkerValid({
  time,
  activeTime
} = {}) {
  return _underscore.default.isNumber(time) && time >= 0 && _underscore.default.isNumber(activeTime) && activeTime >= 0;
}

function getUrl() {
  return (window.location.pathname || '') + (window.location.search || '') + (window.location.hash || '');
}
/**
 * Do not access PerfMarker class directly, use PerfMarker Factory
 */


class PerfMarker {
  constructor(name, markerOptions, isFileFetched, activity, parentMarker) {
    this.markers = {};
    this.InitUrl = getUrl();
    this.isFileFetched = isFileFetched; // is js file already downloaded or not

    this.name = name;
    this.parentMarker = parentMarker;
    this.hierarchy = this.parentMarker.hierarchy ? `${this.parentMarker.hierarchy}.${this.name}` : this.name;
    this.activity = activity;
    this.isDone = false;
    this.autoEnd = markerOptions.autoEnd;
    this.isActiveChild = markerOptions.isActiveChild;
    this.activeChildren = [];
    this.data = markerOptions.data || {};
    this.doneCallback = null;
  }

  createChild(name, markerOptions = {
    autoEnd: false,
    isActiveChild: true
  }) {
    const childMarker = _index.PerfMarkerFactory.createMarker(name, markerOptions, this.activity, this);

    if (childMarker && childMarker.isActiveChild !== false) {
      this.activeChildren.push(childMarker);
    }

    return childMarker;
  }

  willFetchFile() {
    this.markers.timeFetchFile = markTime();
    this.markConsole('willFetchFile');
  }

  willFetchData() {
    this.markers.timeFetchData = markTime();
    this.markConsole('willFetchData');
  }

  willInit() {
    this.markers.timeInit = markTime();
    this.markConsole('willInit');
  }

  willRender() {
    this.markers.timeRender = markTime();
    this.markConsole('willRender');
  }

  onChildDone(childMarker) {
    this.activeChildren = _underscore.default.reject(this.activeChildren, activeChild => activeChild === childMarker);

    if (this.autoEnd && !this.isDone && _underscore.default.isEmpty(this.activeChildren)) {
      this.done();
    }
  }

  done(additionalMessage = {}) {
    this.markers.timeDone = markTime();
    this.markConsole('done');
    this.additionalMessage = additionalMessage; // If marker already done, do not log again

    if (this.isDone) {
      return;
    }

    this.send();
    this.isDone = true;

    if (this.doneCallback && _underscore.default.isFunction(this.doneCallback)) {
      this.doneCallback();
    }

    if (this.parentMarker.onChildDone) {
      this.parentMarker.onChildDone(this);
    }
  }

  markConsole(markerPoint) {
    if (console.timeStamp) {
      console.timeStamp(`PerfMarker ${this.name} ${markerPoint}`);
    }
  }

  send() {
    const message = this.parseMarkers();

    if (_underscore.default.isEmpty(message)) {
      return;
    }

    this.activity.perf(JSON.stringify(message), this.hierarchy);
  }

  parseMarkers() {
    // Calling willFetchFile is optional. If not called, clear file fetching flag
    if (!isMarkerValid(this.markers.timeFetchFile)) {
      this.isFileFetched = true;
    }

    if (_underscore.default.some([this.markers.timeInit, this.markers.timeDone], marker => !isMarkerValid(marker))) {
      return null; // init and done markers should be valid
    }

    const doneUrl = getUrl();
    const didUrlChange = this.InitUrl !== doneUrl;
    return {
      Version: 'perf-marker@0.2.0',
      Name: this.name,
      ParentName: this.parentMarker.name,
      Data: this.data,
      IsParentDone: this.parentMarker.isDone,
      IsPageReadyFulfilled: isPageReadyFulfilled,
      IsFileFetched: this.isFileFetched,
      FileFetchStartTime: _underscore.default.result(this.markers.timeFetchFile, 'time', 0),
      FileFetchActiveStartTime: _underscore.default.result(this.markers.timeFetchFile, 'activeTime', 0),
      DataFetchStartTime: _underscore.default.result(this.markers.timeFetchData, 'time', 0),
      DataFetchActiveStartTime: _underscore.default.result(this.markers.timeFetchData, 'activeTime', 0),
      RenderStartTime: _underscore.default.result(this.markers.timeRender, 'time', 0),
      RenderActiveStartTime: _underscore.default.result(this.markers.timeRender, 'activeTime', 0),
      InitStartTime: this.markers.timeInit.time,
      InitActiveStartTime: this.markers.timeInit.activeTime,
      DoneStartTime: this.markers.timeDone.time,
      DoneActiveStartTime: this.markers.timeDone.activeTime,
      DidUrlChange: didUrlChange,
      InitUrl: didUrlChange ? this.InitUrl : '',
      DoneUrl: didUrlChange ? doneUrl : '',
      AdditionalMessage: this.additionalMessage
    };
  }

}

exports.PerfMarker = PerfMarker;

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__52__;

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncFunctionWithPerfMarker = exports.functionWithPerfMarker = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const functionWithPerfMarker = function functionWithPerfMarker(perfMarker, func, context) {
  if (!_underscore.default.isFunction(func)) {
    return null;
  }

  const newFunc = function newFunc(...args) {
    perfMarker.willInit();
    const result = func.apply(context || this, args);
    perfMarker.done();
    return result;
  };

  return newFunc;
};

exports.functionWithPerfMarker = functionWithPerfMarker;

const asyncFunctionWithPerfMarker = function asyncFunctionWithPerfMarker(perfMarker, asyncFunc, context) {
  if (!_underscore.default.isFunction(asyncFunc)) {
    return null;
  }

  const newAsyncFunc = function newAsyncFunc(...args) {
    perfMarker.willInit();
    return asyncFunc.apply(context || this, args).then(result => {
      perfMarker.done();
      return result;
    });
  };

  return newAsyncFunc;
};

exports.asyncFunctionWithPerfMarker = asyncFunctionWithPerfMarker;

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.perfMarkerPropTypes = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(55));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const perfMarkerPropTypes = _propTypes.default.shape({
  createChild: _propTypes.default.func.isRequired,
  willFetchFile: _propTypes.default.func.isRequired,
  willFetchData: _propTypes.default.func.isRequired,
  willInit: _propTypes.default.func.isRequired,
  willRender: _propTypes.default.func.isRequired,
  done: _propTypes.default.func.isRequired
});

exports.perfMarkerPropTypes = perfMarkerPropTypes;

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__55__;

/***/ })

/******/ })});;
